export default {
	rules: {
		required: "Indicazione richiesta",
		requiredTrailingSpace: "Indicazione richiesta. ",
		onlyWhitespace: "L'immissione non può contenere solo spazi.",
		maxLength35: "Massimo 35 caratteri consentiti.",
		maxLength50: "Massimo 50 caratteri consentiti.",
		maxLength50TrailingSpace: "Massimo 50 caratteri consentiti. ",
		invalidCharacters: 'Contiene caratteri non consentiti "* ^ { } [ ] = < > |"',
		invalidEmail: "Deve essere un indirizzo e-mail valido. ",
		notANumber: "Deve essere un numero.",
		mustBePositive: "Deve essere positivo.",
		noDecimals: "Non sono ammessi decimali",
		notAnInteger: "Deve essere un numero intero.",
		outOfRange0To1000: "Deve essere compreso tra 0 e 1000",
	},
	messages: {
		allUsers: "Tutti gli utenti",
		savedCartQuantitySet:
			"La quantità dell'articolo {articleId} è stata impostata a {quantity} pz. nella distinta base.",
		savedCartQuantityError: "Impossibile modificare la quantità.",
		savedCartRemoveArticleError: "Impossibile rimuovere l'articolo dalla distinta base.",
		savedCartAddArticleError: "Impossibile aggiungere l'articolo alla distinta base.",
		addressDeleted: "L'indirizzo è stato eliminato.",
		addressDeleteError: "Impossibile eliminare l'indirizzo.",
		addressSetPreferred: "L'indirizzo è stato contrassegnato come preferito.",
		addressSetPreferredError: "Impossibile contrassegnare l'indirizzo come preferito.",
		weldlineOne: "1 cordone di saldatura",
		weldlineMultiple: "{count} cordoni di saldatura",
		cornerOne: "1 angolo",
		cornerMultiple: "{count} angoli",
		cleaned: "levigato",
		notCleaned: "non levigato",
		powderFinishMatt: "Opaco",
		powderFinishGlossy: "Lucido",
		notAvailable: "Non disponibile",
		powderStructureSmooth: "Liscio",
		powderStructureFine: "Fine",
		powderStructureRough: "Grezzo",
	},
};
